import { useState, useContext } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import axios from 'axios';
import axiosInstance from '../api/axiosInstance';
import logo from '../assets/FullLogo_1.png';
import { useAuth } from '../context/AuthContext';
import { tokenService } from '../services/tokenService';

const Login = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const auth = useAuth(); // Use the useAuth hook

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError('');
    setLoading(true);
    
    try {
      console.log('📤 Attempting login for:', email);
      
      // Use axiosInstance for consistent interceptors
      const response = await axiosInstance.post('/auth/login', {
        email,
        password,
      });
      
      console.log('✅ Login response:', response.data);
      
      // Validate response
      if (!response.data.token) {
        console.error('❌ No token in response');
        setError('Invalid response from server');
        setLoading(false);
        return;
      }
      
            // Use AuthContext login method
      auth.login(response.data.token, response.data.user);
      console.log('🔑 Token stored and user set');

      // ✅ Notify PermissionsProvider to refetch with the new token
      window.dispatchEvent(new Event('auth-changed'));
      console.log('🔄 Dispatched auth-changed event');

      console.log('🔄 Navigating to dashboard...');
      navigate('/dashboard');
      
    } catch (err: any) {
      console.error('❌ Login error:', err);
      
      if (err.response?.status === 401) {
        setError('Invalid email or password');
      } else if (err.code === 'ERR_NETWORK') {
        setError('Network error. Please check your connection.');
      } else if (err.response?.status === 500) {
        setError('Server error. Please try again later.');
      } else {
        setError(err.response?.data?.error || err.response?.data?.message || 'Login failed. Please try again.');
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50">
      <div className="max-w-md w-full space-y-8 p-8 bg-white rounded-lg shadow">
        <img
          src={logo}
          alt="App Logo"
          className="mx-auto h-30 w-auto"
        />

        {error && <p className="text-red-500">{error}</p>}
        <form onSubmit={handleSubmit} className="space-y-6">
          <div>
            <label htmlFor="email" className="block text-sm font-medium text-gray-700">
              Email
            </label>
            <input
              id="email"
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              className="mt-1 block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-indigo-500 focus:border-indigo-500"
              required
            />
          </div>
          <div>
            <label htmlFor="password" className="block text-sm font-medium text-gray-700">
              Password
            </label>
            <input
              id="password"
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              className="mt-1 block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-indigo-500 focus:border-indigo-500"
              required
            />
          </div>
          <div className="mb-4 text-right">
            <Link to="/forgot-password" className="text-blue-500 hover:underline text-sm">
              Forgot Password?
            </Link>
          </div>
          <button
  type="submit"
  disabled={loading}
  className={`w-full flex justify-center py-2 px-4 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-indigo-600 hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 ${
    loading ? 'opacity-75 cursor-not-allowed' : ''
  }`}
>
  {loading ? 'Logging in...' : 'Login'}
</button>

        </form>
      </div>
    </div>
  );
};

export default Login;